module.exports = __webpack_public_path__ + "3b5a5efe7d65a8f964b0af5eefb8b78d.svg";